// Styles
import styles from './index.module.sass';

export default function TextInput({
  type = 'text',
  name = 'Defaut',
  value = '',
  onChange,
  placeholder,
}) {
  function handleChange(e) {
    if (onChange) onChange(e.target.value);
  }
  return (
    <input
      type={type}
      className={styles.inputText}
      name={name}
      value={value}
      placeholder={placeholder}
      onChange={(e) => handleChange(e)}
    />
  );
}
